export default __webpack_public_path__ + "static/media/imagePlaceholder.87b345b7.webp";